import { useMatch } from "react-router-dom-v5-compat"

import { NAV_DRAWER_CLASSNAME } from "src/components/AppLayout/navUtils"
import { PARADISE_PATH } from "src/router/ParadiseRoutes"
import { MDrawer } from "src/ui/MDrawer/MDrawer"

import { ParadiseSideNav } from "./SideNav/ParadiseSideNav"
import { SideNav } from "./SideNav/SideNav"

export function NavDrawer({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  const isInParadise = useMatch(PARADISE_PATH + "/*")

  return (
    <MDrawer className={NAV_DRAWER_CLASSNAME} open={open} onClose={onClose}>
      {isInParadise ? (
        <ParadiseSideNav navLinkClick={onClose} />
      ) : (
        <SideNav navLinkClick={onClose} />
      )}
    </MDrawer>
  )
}
